/* TODO: t() */
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Text } from '../../../uiold';
import { themeColors } from '../../../uiold/Constants';

import { useEditorState } from '../../EditorContext';

import { TextInputElementDefinition } from '../../../../types/shared/EvaluationForm';
import { FormElementProps } from '../../types';

type Props = FormElementProps<TextInputElementDefinition>;

function TextInputElementReadOnlyView(props: Props) {
  let { definition, style, sortIndex } = props;
  let { submission } = useEditorState();
  let answer = submission && submission.fields[sortIndex];

  return (
    <View style={[styles.root, style]}>
      <Text style={styles.question}>{definition.question}</Text>
      <Text style={styles.answer}>{answer || ''}</Text>
    </View>
  );
}

let styles = StyleSheet.create({
  root: {
    padding: 16,
    backgroundColor: themeColors.white,
  },
  question: {
    marginBottom: 8,
    fontSize: 14,
  },
  answer: {},
});

export default TextInputElementReadOnlyView;
